'use client'
import React, {useEffect} from "react";
import UserService from "@/services/Nest/user.service";
import {useAppDispatch, useAppSelector} from "@/lib/hooks/store";
import {fetchUserData, resetAuth, setApplication, setAuth, setUser} from "@/lib/store/features/user/userSlice";
import {getAuth} from "@/lib/store/features/user/selectors";
import LoadingPage from "@/components/layout/loading-page";
import ApplicationService from "@/services/Bubble/finsey/ApplicationService";

const AuthProvider = ({children}: { children: React.ReactNode }) => {
    const dispatch = useAppDispatch();
    const { triggerFetch } = useAppSelector(getAuth)



    useEffect(() => {
        dispatch(fetchUserData())
    }, []);

    return (
        <>{children}</>
    )
}

export default AuthProvider